import React from "react";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button } from "antd";

const CustomBackButton = ({
  onBack,
  buttonText = "Back",
  buttonIcon = <ArrowLeftOutlined />,
  iconPosition = "left",
  className = "",
  leftExtra = null,
  extraa = null,
}) => {
  return (
    <div className="flex items-center justify-between gap-2 mb-6">
      <div className="flex items-center flex-1">
        <Button
          type="text"
          iconPosition={iconPosition}
          icon={buttonIcon}
          onClick={onBack}
          className={className}
        />
        <h2 className="text-xl font-medium">{buttonText}</h2>
        {leftExtra && <div className="ml-4">{leftExtra}</div>}
      </div>
      {extraa && <div className="ml-auto">{extraa}</div>}
    </div>
  );
};

export default CustomBackButton;
